import { TextField } from '@mui/material';
import { useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { LinkWrapper } from './styles';

export const DownloadField = () => {
  const { t } = useTranslation('form');
  const { values } = useFormState();
  const disabled = !values?.mandatePdfUrl;

  const handleClick = (e: React.MouseEvent) => {
    if (disabled) {
      e.preventDefault();
    }
  };

  return (
    <TextField
      disabled
      label={t('field.mandate')}
      fullWidth
      InputProps={{
        readOnly: true,
        sx: {
          '& input': {
            display: 'none'
          }
        },
        startAdornment: (
          <LinkWrapper
            disabled={disabled}
            href={disabled ? undefined : values?.mandatePdfUrl}
            onClick={handleClick}
            target="_blank"
            download
          >
            {t('download pdf mandate')}
          </LinkWrapper>
        )
      }}
    />
  );
};
